import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import EasyEdit from 'react-easy-edit';
import moment from 'moment';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Button, Loader, colors } from 'kangarootime-ui';
import KTTags from '../../../components/common/KTTags';
import actions from './duck/actions';

class Centers extends Component {
  constructor (props) {
    super(props);
    this.state = { name: '', legacyId: '', tags: [] };
  }
  componentDidMount = () => {
    this.props.getCenters();
  };

  componentWillUnmount = () => {
    this.props.unsubscribeCenters();
  };

  createCenter () {
    this.props.createCenter({
      name: this.state.name,
      legacyId: this.state.legacyId,
      tags: this.state.tags
    });
    this.setState({ name: '', legacyId: '', tags: [] });
  }

  deleteCenter (id, version) {
    this.props.deleteCenter(id, version);
  }

  render () {
    return (
      <Fragment>
        <Loader loading={this.props.fetchingCenters}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Legacy Id</TableCell>
                <TableCell>Tags</TableCell>
                <TableCell>Created</TableCell>
                <TableCell>Updated</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.centers.map(center => (
                <TableRow key={center.id}>
                  <TableCell>{center.id}</TableCell>
                  <TableCell>
                    <Loader
                      loading={this.props.updatingCenterById[center.id]}
                    >
                      <EasyEdit
                        type='text'
                        value={center.name}
                        onSave={value =>
                          this.props.updateCenter(
                            center.id,
                            { name: value },
                            center.version
                          )
                        }
                      />
                    </Loader>
                  </TableCell>
                  <TableCell>
                    <Loader
                      loading={this.props.updatingCenterById[center.id]}
                    >
                      <EasyEdit
                        type='text'
                        value={center.legacyId}
                        onSave={value =>
                          this.props.updateCenter(
                            center.id,
                            { legacyId: value },
                            center.version
                          )
                        }
                      />
                    </Loader>
                  </TableCell>
                  <TableCell>
                    <Loader
                      loading={this.props.updatingCenterById[center.id]}
                    >
                      <KTTags
                        tags={center.tags || []}
                        onTagsChange={value =>
                          this.props.updateCenter(
                            center.id,
                            { tags: value },
                            center.version
                          )
                        }
                      />
                    </Loader>
                  </TableCell>
                  <TableCell>
                    {moment(center.createdAt).format('YYYY-MM-DD HH:mm:ss')}
                  </TableCell>
                  <TableCell>
                    {moment(center.updatedAt).format('YYYY-MM-DD HH:mm:ss')}
                  </TableCell>
                  <TableCell>
                    <Loader
                      loading={this.props.deletingCenterById[center.id]}
                    >
                      <Button
                        type='secondary'
                        color={colors.danger}
                        onClick={() =>
                          this.deleteCenter(center.id, center.version)
                        }
                      >
                        Delete
                      </Button>
                    </Loader>
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell>(New)</TableCell>
                <TableCell>
                  <input
                    type='text'
                    onChange={e => this.setState({ name: e.target.value })}
                    value={this.state.name}
                  />
                </TableCell>
                <TableCell>
                  <input
                    type='text'
                    onChange={e => this.setState({ legacyId: e.target.value })}
                    value={this.state.legacyId}
                  />
                </TableCell>
                <TableCell>
                  <KTTags
                    tags={this.state.tags}
                    onTagsChange={value => this.setState({ tags: value })}
                  />
                </TableCell>
                <TableCell />
                <TableCell />
                <TableCell>
                  <Loader loading={this.props.creatingCenter}>
                    <Button
                      type='primary'
                      onClick={() => this.createCenter()}
                    >
                      Add New
                    </Button>
                  </Loader>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Loader>
      </Fragment>
    );
  }
}

function mapStateToProps (state) {
  return {
    centerId: state.identity.centerId,
    fetchingCenters: state.admin.centers.fetchingCenters,
    centers: state.admin.centers.centers,
    creatingCenter: state.admin.centers.creatingCenter,
    updatingCenterById: state.admin.centers.updatingCenterById,
    deletingCenterById: state.admin.centers.deletingCenterById
  };
}

function mapDispatchToProps (dispatch) {
  return {
    createCenter: center => dispatch(actions.createCenterRequest(center)),
    deleteCenter: (id, version) =>
      dispatch(actions.deleteCenterRequest(id, version)),
    updateCenter: (id, center, version) =>
      dispatch(actions.updateCenterRequest(id, center, version)),
    getCenters: () => dispatch(actions.getCentersRequest()),
    unsubscribeCenters: () => dispatch(actions.unsubscribeCenters())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Centers);
